// @ts-nocheck
if(!customElements.get('product-media-gallery')) {
    class ProductMediaGallery extends HTMLElement {
        constructor() {
            super();
            this.variantIdChangedUnsubscriber = undefined;
            this.galleryImageChangedUnsubscriber = undefined;
            this.swiperThumbnails = null;
            this.swiperMain = null;
            this.productDataCache = null;
            this.lastPathname = '';
        }
        async connectedCallback() {
            // 2. Cache product data
            const currentPath = window.location.pathname;
            if (!this.productDataCache || this.lastPathname !== currentPath) {
                try {
                    const res = await fetch(`${currentPath}.json`);
                    this.productDataCache = await res.json();
                    this.lastPathname = currentPath;
                } catch (err) {
                    console.error('Fetch error:', err);
                    return;
                }
            }
            this.onChangedGalleryImageUnsubscriber = subscribe(
                PUB_SUB_EVENTS.changedGalleryImage,
                this._findVariantImage.bind(this)
            );
            this.onGalleryImageChangedUnsubcriber = subscribe(
                PUB_SUB_EVENTS.galleryImageChanged,
                this._setGalleryImage.bind(this)
            );
            this.onBorderMatChangedUnsubscriber = subscribe(
                PUB_SUB_EVENTS.borderMatChanged,
                this._borderMatChanged.bind(this)
            );
            this.swiperThumbnails = new Swiper(".gallery-thumbnails", {
                spaceBetween: 10,
                watchSlidesProgress: true,
                slidesPerView: 6.6,
                breakpoints: {
                    0: {
                        slidesPerView: 5.2,
                        spaceBetween: 8,
                         
                    },
                    768: {
                        slidesPerView: 6.6,
                        spaceBetween: 10,
                    }
                }
            });
            this.swiperMain = new Swiper(".main-gallery", {
                spaceBetween: 10,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                thumbs: {
                    swiper: this.swiperThumbnails,
                },
                on: {
                    slideChange: function () {
                        const activeIndex = this.activeIndex;
                        const thumbSwiper = this.thumbs?.swiper;
                        if (!thumbSwiper) return;
                        
                        // Get actual rendered slides per view
                        const visibleThumbs = thumbSwiper.slidesPerViewDynamic 
                                            || thumbSwiper.params.slidesPerView;
                        
                        // Convert to number if it's 'auto'
                        const visibleThumbsCount = typeof visibleThumbs === 'number' 
                                                ? visibleThumbs 
                                                : Math.floor(thumbSwiper.width / thumbSwiper.slides[0]?.swiperSlideSize);
                        if (activeIndex >= thumbSwiper.activeIndex + visibleThumbsCount - 2) {
                            thumbSwiper.slideTo(activeIndex - 2);
                        }

                        if (activeIndex < thumbSwiper.activeIndex) {
                            thumbSwiper.slideTo(Math.max(activeIndex - 2, 0));
                        }
                        if(this.el.dataset.orientation === 'false') {
                            thumbSwiper.el.classList.add('active');
                            return;
                        }
                        thumbSwiper.slides.map((slide, index) => {
                            const shouldShow = this.el.dataset.matBorder !== 'false' ? slide.dataset.galleryImage.includes(this.el.dataset.orientation) && slide.dataset.galleryImage.includes(this.el.dataset.matBorder) && slide.dataset.galleryImage.includes('sub') || slide.dataset.galleryImage.includes(this.el.dataset.orientation) && slide.dataset.galleryImage.includes('main') && slide.dataset.galleryImage.includes(this.el.dataset.style) && slide.dataset.galleryImage.includes(this.el.dataset.matBorder) : slide.dataset.galleryImage.includes(this.el.dataset.orientation) && slide.dataset.galleryImage.includes('sub') || slide.dataset.galleryImage.includes(this.el.dataset.orientation) && slide.dataset.galleryImage.includes(this.el.dataset.style) && slide.dataset.galleryImage.includes('main');
                            shouldShow ? slide.classList.add('active-thumbs') : slide.classList.remove('active-thumbs');
                            shouldShow ? this.slides[index].classList.add('active-main') : this.slides[index].classList.remove('active-main');
                        });
                        // Important: Update swiper after DOM changes
                        setTimeout(() => {
                                thumbSwiper.update(); // Update thumbnail swiper
                                this.slideTo(this.activeIndex);
                                thumbSwiper.el.classList.add('active');
                        }, 50);
                    },
                    afterInit: function() {
                        const matchedSlides = this.slides.filter(slide => slide.dataset.galleryImage.includes('main') && slide.dataset.galleryImage.includes(this.el.dataset.orientation) && slide.dataset.galleryImage.includes(this.el.dataset.style));
                        this.slideTo(parseInt(matchedSlides[0].dataset.index));
                        this.el.classList.add('active');
                    },
                    slideChangeTransitionStart: function () {
                        const activeThumbsSlides = this.thumbs.swiper.slides.filter(
                            slide => slide.classList.contains('active-thumbs')
                        );

                        const currentIndexSlide = activeThumbsSlides.findIndex(slide =>
                            slide.classList.contains('swiper-slide-thumb-active')
                        );

                        // If no active slide found (-1)
                        if (currentIndexSlide === -1) {
                            const isMovingRight = this.activeIndex > this.previousIndex;
                            if(isMovingRight) {
                                const activeSlideIndex = activeThumbsSlides.findIndex(slide =>
                                    parseInt(slide.dataset.index) === parseInt(this.previousIndex)
                                );                                    
                                const numberOfIndex = (activeSlideIndex + 1) < activeThumbsSlides.length ? activeSlideIndex + 1 : activeThumbsSlides.length - 1;
                                const nextSlideIndex = activeThumbsSlides[numberOfIndex];
                                this.slideTo(parseInt(nextSlideIndex.dataset.index));
                            } else {
                                const activeSlideIndex = activeThumbsSlides.findIndex(slide =>
                                    parseInt(slide.dataset.index) === parseInt(this.previousIndex)
                                );           
                                this.slideTo(
                                    activeSlideIndex === 1 
                                        ? parseInt(activeThumbsSlides[0].dataset.index)
                                        : activeSlideIndex === 0
                                            ? parseInt(activeThumbsSlides[0].dataset.index)
                                            : parseInt(activeThumbsSlides[activeSlideIndex - 1].dataset.index)
                                );
                            }
                            return; // Prevent double slide
                        }
                    }
                  }
            });
            this.swiperMain.emit('slideChange');
        }
      
        disconnectedCallback() {
            if (this.variantIdChangedUnsubscriber) {
                this.variantIdChangedUnsubscriber();
            }
        }

        async _findVariantImage({ data: { event } }) {
            const orientationIsPresent = event.target.closest('.variant-picker__form')?.querySelector('[data-option-handle="orientation"]');
            const selectedOptionsInputs = document.querySelectorAll('.variant-option__button-label input:checked');
            const selectedMatOptionInput = document.querySelector('[data-option-handle="border-mat-options"] input:checked');
            const styleIsPresent = document.querySelector('[data-option-handle="style"] input:checked');
            const selectedOptionsValue = [];
            selectedOptionsInputs.length > 0 && Array.from(selectedOptionsInputs).map(input => {
                selectedOptionsValue.push(input.value);
            })
            const marBorderRef = document.querySelector('[ref="mat_border"]');
            if(selectedMatOptionInput && marBorderRef) {
                marBorderRef.name = 'properties[Mat Border]';
                marBorderRef.value = selectedMatOptionInput.value;
            } else {
                marBorderRef.name = 'property[Mat Border]';
            }
            this.swiperMain.el.dataset.matBorder = selectedMatOptionInput ? selectedMatOptionInput.value.toLowerCase().replaceAll(' ', '-') : false;
            this.swiperMain.el.dataset.orientation = orientationIsPresent ? selectedOptionsValue[0].toLowerCase() : false;
            this.swiperMain.el.dataset.style = styleIsPresent ? `${styleIsPresent.value.toLowerCase().replaceAll(' ', '-')}` : false;
            // 1. Fast path for empty selections
            if (!selectedOptionsValue?.length) return;

            // 3. Fast exit if no variants
            const variants = this.productDataCache.product?.variants;
            if (!variants || !variants.length) return;

            // 4. Pre-process search terms once
            const searchTerms = new Set(
                selectedOptionsValue.map(opt => opt.toLowerCase().trim())
            );

            // 5. Optimized search using for...of loop
            let matchedVariant = null;
            for (const variant of variants) {
                const variantTitle = variant.title.toLowerCase();
                let allMatch = true;
                
                for (const term of searchTerms) {
                    if (!variantTitle.includes(term)) {
                        allMatch = false;
                        break; // Early exit inner loop
                    }
                }
                
                if (allMatch) {
                    matchedVariant = variant;
                    break; // Early exit outer loop
                }
            }
            // 6. Fast DOM lookup
            let matImageId = [];
            const optionMatIsPresent = document.querySelector('[data-option-handle="border-mat-options"]');
            const optionStyleIsPresent = document.querySelector('[data-option-handle="style"] input:checked');
            if(this.swiperMain.el.dataset.matBorder !== 'false' && optionMatIsPresent && optionStyleIsPresent) {
                const styleHandle = optionStyleIsPresent.value.toLowerCase().replaceAll(' ','-');
                matImageId = (event.target.closest('[data-option-handle="style"]') || event.target.closest('[data-option-handle="border-mat-options"]')) ? this.swiperMain.slides.filter(slide => slide.dataset.galleryImage.includes(styleHandle) && slide.dataset.galleryImage.includes(this.swiperMain.el.dataset.orientation) && slide.dataset.galleryImage.includes(this.swiperMain.el.dataset.matBorder) && slide.dataset.galleryImage.includes('sub')) : this.swiperMain.slides.filter(slide => slide.dataset.galleryImage.includes(styleHandle) && slide.dataset.galleryImage.includes(this.swiperMain.el.dataset.orientation) && slide.dataset.galleryImage.includes(this.swiperMain.el.dataset.matBorder) && slide.dataset.galleryImage.includes('main'));
            } else {
                const styleHandle = optionStyleIsPresent.value.toLowerCase().replaceAll(' ','-');
                matImageId = (event.target.closest('[data-option-handle="border-options"]') || optionStyleIsPresent === 'stretched-canvas' && !event.target.closest('[data-option-handle="orientation"]') || event.target.closest('[data-option-handle="style"]')) ? this.swiperMain.slides.filter(slide => slide.dataset.galleryImage.includes('sub') && slide.dataset.galleryImage.includes(styleHandle) && slide.dataset.galleryImage.includes(this.swiperMain.el.dataset.orientation) && slide.dataset.galleryImage.includes('border-wrap')) : this.swiperMain.slides.filter(slide => slide.dataset.galleryImage.includes('main') && slide.dataset.galleryImage.includes(styleHandle) && slide.dataset.galleryImage.includes(this.swiperMain.el.dataset.orientation));
            }
            
            if (matchedVariant?.image_id && this.swiperMain) {
                const selector = `[data-image-id="${matchedVariant.image_id}"]`;
                const imageEl = this.querySelector(selector);
                if (imageEl) {                    
                    this.swiperMain.slideTo(matImageId.length > 0 ? parseInt(matImageId[0].dataset.index) : parseInt(imageEl.dataset.index));
                }
            }            
        }
        async _setGalleryImage({data: { galleryImage }}) {
            const slideGalleryImage = document.querySelector(`[data-gallery-image="files/${galleryImage}"]`);
            slideGalleryImage && this.swiperMain.slideTo(parseInt(slideGalleryImage.dataset.index));
        }
        _borderMatChanged({data: { event, orientation, productStyleData }}) {
            const currentStyle = document.querySelector('[data-option-handle="style"] input:checked');
            const styleHandle = currentStyle.value.toLowerCase().replaceAll(' ','-');
            const visibleThumbnails = this.swiperMain.slides.filter(slide => slide.dataset.galleryImage.includes(this.swiperMain.el.dataset.matBorder) && slide.dataset.galleryImage.includes(orientation) && slide.dataset.galleryImage.includes(styleHandle));
            visibleThumbnails.length > 0 && this.swiperMain.slideTo(parseInt(visibleThumbnails[0].dataset.index)); 
            const matHandle = event.target.value.toLowerCase().replaceAll(' ','-');
            const styleImages = productStyleData.filter(style => style.image.reference.image.url.includes(matHandle));
            const styleInputs = document.querySelectorAll('[data-option-handle="style"] .variant-option__button-label input');
            if(styleInputs.length > 0) {
                styleInputs.forEach(input => {
                    const imgSrc = styleImages.filter(image => image.label.value.includes(input.value));
                    const spanImage = input.closest('label').querySelector('.swatch');
                    spanImage & spanImage.style.setProperty('--swatch-background', `url(${imgSrc})`);
                })
            }
        }
    }
    customElements.define('product-media-gallery', ProductMediaGallery);
}